module.exports = __webpack_public_path__ + "static/media/IMDb_logo.64099c07.svg";